module.exports = __webpack_public_path__ + "front/img/bmbg01.4acc6354.png";